import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import "./Question.css";

const QSetRelation = () => {
  const navigate = useNavigate();
  const [activeTab, setActiveTab] = useState("numerical");

  const numericalQuestions = [
    {
      question:
        "Ques(1). Let S = {1, 2, 3, 4, 5, 6}. Then the number of elements in the set {A ⊆ S : 1 ∈ A, 2 ∉ A} is. [IIT-JEE Adv. (2023)]",
      answer: "32",
    },
    {
      question:
        "Ques(2). Let R be the relation on the set of integers Z defined by mRn if m-n is divisible by 7. Then, the number of equivalence classes is. [IIT-JEE Adv. (2022)]",
      answer: "7",
    },
    {
      question:
        "Ques(3). Let A = {1, 2, 3, 4, 5}. The number of relations from A to A which are symmetric and contain (1, 2) and (2, 3) is 2^k. Then k is equal to. [IIT-JEE Adv. (2021)]",
      answer: "10",
    },
    {
      question:
        "Ques(4). Let S = {1, 2, 3, 4}. Then the number of elements in the set { (A, B) : A ⊆ B ⊆ S } is. [IIT-JEE Adv. (2020)]",
      answer: "81",
    },
    {
      question:
        "Ques(5). Let A = {1, 2, 3}. Then the number of relations containing (1, 2) and (1, 3) which are reflexive and symmetric but not transitive is. [IIT-JEE Adv. (2018)]",
      answer: "1",
    },
    {
      question:
        "Ques(6). Let S = {1, 2, 3, ..., 9}. For k = 1, 2, ..., 5, let Nk be the number of subsets of S, each containing five elements out of which exactly k are odd. Then N1 + N2 + N3 + N4 + N5 = [IIT-JEE Adv. (2017)]",
      answer: "126",
    },
    {
      question:
        "Ques(7). Let A and B be two sets containing four and two elements respectively. Then the number of subsets of the set A × B, each having at least three elements is. [IIT-JEE Adv. (2013)]",
      answer: "219",
    },
    {
      question:
        "Ques(8). The total number of distinct x ∈ R for which  | x x^2 1+x^3 | | 2x 3x^2 1+8x^3 | | 3x 5x^2 1+27x^3 | = 10 is. [IIT-JEE Adv. (2011)]",
      answer: "2",
    },
    {
      question:
        "Ques(9). Let f(x)=x^2+1, Then the number of real roots of equation f(f(x))=x is [IIT-JEE Adv. (2010)]",
      answer: "0",
    },
    {
      question:
        "Ques(10). Let A = {1, 2, 3, 4, 5, 6}. Let R be a relation on A defined by R = {(a, b) : a, b ∈ A, a + b is even}. Then, the number of elements in R is. [IIT-JEE Mains (2023)]",
      answer: "18",
    },
    {
      question:
        "Ques(11). Let A = {1, 2, 3, 4, 5, 6, 7}. Then, the number of onto functions from A to {8, 9} is. [IIT-JEE Mains (2022)]",
      answer: "126",
    },
    {
      question:
        "Ques(12). Let A = {a, b, c}. Then, the total number of distinct relations from A to A which are either reflexive or symmetric or both is. [IIT-JEE Mains (2021)]",
      answer: "250",
    },
    {
      question:
        "Ques(13). Let A = {1, 2, 3, 4, 5, 6, 7}. Then, the number of onto functions from A to {8, 9} is. [IIT-JEE Mains (2020)]",
      answer: "126",
    },
    {
      question:
        "Ques(14). Let R = {(x, y) : x, y ∈ Z, x^2 + 3y^2 ≤ 8}. Then the number of elements in R is. [IIT-JEE Mains (2019)]",
      answer: "27",
    },
    {
      question:
        "Ques(15). Let A = {1, 2, 3, ..., 10}. Then the number of subsets of A containing only odd numbers is. [IIT-JEE Mains (2018)]",
      answer: "32",
    },
    {
      question:
        "Ques(16). If A = {1, 2, 3, 4, 5}, then the number of subsets of A containing 2 and 3 is. [IIT-JEE Mains (2017)]",
      answer: "8",
    },
    {
      question:
        "Ques(17). Let A = {1, 2, 3, 4, 5}. Then the number of relations on A which are reflexive and symmetric is. [IIT-JEE Mains (2016)]",
      answer: "32768",
    },
    {
      question:
        "Ques(18). Let A = {1, 2, 3, 4, 5}. Then the number of relations on A which are reflexive is. [IIT-JEE Mains (2015)]",
      answer: "2^20",
    },
    {
      question:
        "Ques(19). If A and B are two sets such that n(A) = 3, n(B) = 6 and A ⊂ B, then number of elements in B \\ A is. [IIT-JEE Mains (2014)]",
      answer: "3",
    },
    {
      question:
        "Ques(20). Let A = {1, 2, 3, 4, 5}. Then the number of onto functions from A to {6, 7} is. [IIT-JEE Mains (2013)]",
      answer: "30",
    },
    {
      question:
        "Ques(21). Let R be a relation defined by R = {(a, b) : a, b ∈ Z, a - b is even}. Then, the number of equivalence classes is. [IIT-JEE Mains (2012)]",
      answer: "2",
    },
    {
      question:
        "Ques(22). If A = {1, 2, 3, 4}, then the number of equivalence relations on A having exactly two equivalence classes is. [IIT-JEE Mains (2011)]",
      answer: "7",
    },
    {
      question:
        "Ques(23). Let R = {(x, y) : x, y ∈ N, x + 2y = 8} be a relation on N. Then the number of elements in R is [IIT-JEE Mains (2010)]",
      answer: "3",
    },
  ];

  const mcqQuestions = [
    {
      question:
        "Ques(1). Let S = {1, 2, 3, ..., 9}. For k = 1, 2, ..., 5, let Nk be the number of subsets of S, each containing five elements out of which exactly k are odd. Then Σk=1^5 Nk is equal to: [IIT-JEE Adv. (2023)]",
      options: ["126", "252", "504", "210"],
      answer: "126",
    },
    {
      question:
        "Ques(2). Let R be a relation on the set of integers Z defined by mRn if m-n is divisible by 7. Which of the following statements is/are true? [IIT-JEE Adv. (2022)]",
      options: ["R is reflexive", "R is symmetric", "R is transitive", "All of the above"],
      answer: "All of the above",
    },
    {
      question:
        "Ques(3). Let A = {1, 2, 3, 4, 5}. The number of relations from A to A which are symmetric and contain (1, 2) and (2, 3) is 2^k. Then k is equal to: [IIT-JEE Adv. (2021)]",
      options: ["6", "8", "10", "12"],
      answer: "10",
    },
    {
      question:
        "Ques(4). Let S = {1, 2, 3, 4}. Then the number of elements in the set { (A, B) : A ⊆ B ⊆ S } is: [IIT-JEE Adv. (2020)]",
      options: ["16", "27", "81", "256"],
      answer: "81",
    },
    {
      question:
        "Ques(5). Let A = {1, 2, 3}. Then the number of relations containing (1, 2) and (1, 3) which are reflexive and symmetric but not transitive is: [IIT-JEE Adv. (2018)]",
      options: ["1", "2", "3", "4"],
      answer: "1",
    },
    {
      question:
        "Ques(6). Let S = {1, 2, 3, ..., 9}. For k = 1, 2, ..., 5, let Nk be the number of subsets of S, each containing five elements out of which exactly k are odd. Then N1 + N2 + N3 + N4 + N5 = [IIT-JEE Adv. (2017)]",
      options: ["126", "252", "504", "210"],
      answer: "126",
    },
    {
      question:
        "Ques(7). Let A and B be two sets containing four and two elements respectively. Then the number of subsets of the set A × B, each having at least three elements is: [IIT-JEE Adv. (2013)]",
      options: ["219", "256", "275", "510"],
      answer: "219",
    },
    {
      question: "Ques(8). Let f(x)=x^2+1, Then the number of real roots of equation f(f(x))=x is [IIT-JEE Adv. (2010)]",
      options: ["0", "1", "2", "4"],
      answer: "0",
    },
    {
      question:
        "Ques(9). Let A = {1, 2, 3, 4, 5, 6}. Let R be a relation on A defined by R = {(a, b) : a, b ∈ A, a + b is even}. Then, the number of elements in R is: [IIT-JEE Mains (2023)]",
      options: ["18", "12", "15", "21"],
      answer: "18",
    },
    {
      question:
        "Ques(10). Let A = {1, 2, 3, 4, 5, 6, 7}. Then, the number of onto functions from A to {8, 9} is: [IIT-JEE Mains (2022)]",
      options: ["126", "210", "252", "504"],
      answer: "126",
    },
    {
      question:
        "Ques(11). Let A = {a, b, c}. Then, the total number of distinct relations from A to A which are either reflexive or symmetric or both is: [IIT-JEE Mains (2021)]",
      options: ["250", "256", "288", "300"],
      answer: "250",
    },
    {
      question:
        "Ques(12). Let A = {1, 2, 3, 4, 5, 6, 7}. Then the number of onto functions from A to {8, 9} is: [IIT-JEE Mains (2020)]",
      options: ["126", "210", "252", "504"],
      answer: "126",
    },
    {
      question:
        "Ques(13). Let R = {(x, y) : x, y ∈ Z, x^2 + 3y^2 ≤ 8}. Then the number of elements in R is: [IIT-JEE Mains (2019)]",
      options: ["27", "25", "23", "21"],
      answer: "27",
    },
    {
      question:
        "Ques(14). Let A = {1, 2, 3, ..., 10}. Then the number of subsets of A containing only odd numbers is: [IIT-JEE Mains (2018)]",
      options: ["32", "64", "128", "256"],
      answer: "32",
    },
    {
      question:
        "Ques(15). If A = {1, 2, 3, 4, 5}, then the number of subsets of A containing 2 and 3 is: [IIT-JEE Mains (2017)]",
      options: ["8", "16", "32", "64"],
      answer: "8",
    },
    {
      question:
        "Ques(16). Let A = {1, 2, 3, 4, 5}. Then the number of relations on A which are reflexive and symmetric is: [IIT-JEE Mains (2016)]",
      options: ["32768", "65536", "1048576", "2097152"],
      answer: "32768",
    },
    {
      question:
        "Ques(17). Let A = {1, 2, 3, 4, 5}. Then the number of relations on A which are reflexive is: [IIT-JEE Mains (2015)]",
      options: ["2^20", "2^25", "2^10", "2^5"],
      answer: "2^20",
    },
    {
      question:
        "Ques(18). If A and B are two sets such that n(A) = 3, n(B) = 6 and A ⊂ B, then number of elements in B \\ A is: [IIT-JEE Mains (2014)]",
      options: ["3", "4", "5", "6"],
      answer: "3",
    },
    {
      question:
        "Ques(19). Let A = {1, 2, 3, 4, 5}. Then the number of onto functions from A to {6, 7} is: [IIT-JEE Mains (2013)]",
      options: ["30", "32", "60", "120"],
      answer: "30",
    },
    {
      question:
        "Ques(20). Let R be a relation defined by R = {(a, b) : a, b ∈ Z, a - b is even}. Then, the number of equivalence classes is: [IIT-JEE Mains (2012)]",
      options: ["1", "2", "3", "Infinite"],
      answer: "2",
    },
    {
      question:
        "Ques(21). If A = {1, 2, 3, 4}, then a relation on A that is reflexive, symmetric and transitive is:  [IIT-JEE Mains (2011)]",
      options: [
        "{(1, 1), (2, 2), (3, 3), (4, 4)}",
        "{(1, 2), (2, 1), (3, 4), (4, 3)}",
        "{(1, 1), (2, 2), (3, 3), (4, 4), (1, 2), (2, 1)}",
        "{(1, 2), (2, 3), (3, 4), (4, 1)}",
      ],
      answer: "{(1, 1), (2, 2), (3, 3), (4, 4)}",
    },
    {
      question:
        "Ques(22). Let A and B be two sets having 3 elements each.  The number of relations from A to B is [IIT-JEE Mains (2010)]",
      options: ["9", "2^9", "3^9", "9^2"],
      answer: "2^9",
    },
  ];

  const [showAnswer, setShowAnswer] = useState(Array(numericalQuestions.length).fill(false));
  const [selectedAnswers, setSelectedAnswers] = useState(Array(mcqQuestions.length).fill(null));

  // Toggle answer visibility for numerical questions
  const toggleAnswer = (index) => {
    const updatedAnswers = [...showAnswer];
    updatedAnswers[index] = !updatedAnswers[index];
    setShowAnswer(updatedAnswers);
  };

  // Handle MCQ option selection
  const handleOptionSelect = (qIndex, option) => {
    const updatedSelectedAnswers = [...selectedAnswers];
    // Lock selection after first click (optional: remove to allow change)
    if (updatedSelectedAnswers[qIndex] === null) {
      updatedSelectedAnswers[qIndex] = option;
      setSelectedAnswers(updatedSelectedAnswers);
    }
  };

  return (
    <div className="question-page">
      <h1 className="question-heading">Previous Year Questions for "Sets and Relations"</h1>

      <div className="tab-container">
        <button
          className={`tab-btn ${activeTab === "numerical" ? "active" : ""}`}
          onClick={() => setActiveTab("numerical")}
        >
          Numerical Questions
        </button>
        <button className={`tab-btn ${activeTab === "mcq" ? "active" : ""}`} onClick={() => setActiveTab("mcq")}>
          MCQ Questions
        </button>
      </div>

      <div className="question-container">
        {/* Numerical Section */}
        <div className={`question-section ${activeTab === "numerical" ? "visible" : "hidden"}`}>
          <h2 className="section-title">Numerical-Based Questions</h2>
          <div className="scrollable-content">
            {numericalQuestions.map((item, index) => (
              <div key={index} className="question-item">
                <p className="question-text">{item.question}</p>
                <button className="answer-btn" onClick={() => toggleAnswer(index)}>
                  {showAnswer[index] ? "Hide Answer" : "View Answer"}
                </button>
                {showAnswer[index] && <p className="answer-text">{item.answer}</p>}
              </div>
            ))}
          </div>
        </div>

        {/* MCQ Section */}
        <div className={`question-section ${activeTab === "mcq" ? "visible" : "hidden"}`}>
          <h2 className="section-title">MCQ-Based Questions</h2>
          <div className="scrollable-content">
            {mcqQuestions.map((item, qIndex) => (
              <div key={qIndex} className="question-item">
                <p className="question-text">{item.question}</p>
                <ul className="options-list">
                  {item.options.map((option, optIndex) => {
                    let className = "option";
                    if (selectedAnswers[qIndex] !== null) {
                      if (option === item.answer) className += " correct";
                      else if (selectedAnswers[qIndex] === option) className += " incorrect";
                    }
                    return (
                      <li
                        key={optIndex}
                        className={className}
                        onClick={() => handleOptionSelect(qIndex, option)}
                        role="button"
                        tabIndex={0}
                        onKeyDown={(e) => {
                          if (e.key === "Enter" || e.key === " ") {
                            handleOptionSelect(qIndex, option);
                          }
                        }}
                      >
                        {option}
                      </li>
                    );
                  })}
                </ul>
              </div>
            ))}
          </div>
        </div>
      </div>

      <button className="back-home-btn" onClick={() => navigate(-1)}>
        ⬅ Go Back to Other Chapter
      </button>
    </div>
  );
};

export default QSetRelation;
